/*
 * @Author: DT
 * @Date: 2022-10-19 09:38:52
 * @LastEditors: DT
 * @LastEditTime: 2022-11-09 21:01:15
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/returnGoods/list/list.js
 */
import { returnTakeListApi } from "@/libs/api";
export default {
  data() {
    return {
      listStatus: 1,
      listData: [],
    };
  },
  mounted() {
    window.dsBridge &&
      window.dsBridge.call("setNativeTitle", {
        title: "",
      });
    this.$toast.loading({
      duration: 0,
      mask: true,
      message: "加载中...",
    });
    console.log('this.$cookies.get("ul_utk")', this.$cookies.get("ul_utk"));
    this.getList();
  },
  methods: {
    handleMobile(phone) {
      console.log("phone", phone);
      // Android
      if (navigator.userAgent.indexOf("Android") > -1) {
        window.location.href = `tel:${phone}`;
      }
      // IOS
      else {
        let dataString = {
          urlScheme: `tel:${phone}`,
        };
        window.dsBridge.call("generalAction", {
          type: "8",
          ios_action: JSON.stringify(dataString),
        });
      }
    },
    handleBackApp() {
      // this.$postingApp.goBack();
      // window.dsBridge.call("generalAction", {
      //   type: "0",
      //   ios_action: "ulePopView",
      //   android_action: "ulePopView",
      // });
      console.log("返回");
      window.location.href = "ulemobile://ulePopView";
    },
    getList() {
      returnTakeListApi()
        .then((res) => {
          if (res.returnCode == "0000") {
            if (res.result && res.result.list) {
              this.listData = res.result.list;
              if (this.listData.length > 0) {
                this.listStatus = 2;
                this.listData.forEach((ele) => {
                  switch (ele.returnTakeStatus) {
                    case "100":
                      ele.returnTakeStatusText = "待排线";
                      break;
                    case "200":
                      ele.returnTakeStatusText = "待取货";
                      break;
                    case "600":
                      if (ele.subReturnTakeStatus == "6100") {
                        ele.returnTakeStatusText = "全部取货";
                      } else if (ele.subReturnTakeStatus == "6101") {
                        ele.returnTakeStatusText = "部分取货";
                      } else if (ele.subReturnTakeStatus == "6900") {
                        ele.returnTakeStatusText = "未取到货";
                      }
                      break;
                  }
                });
              } else {
                this.listStatus = 3;
              }
            } else {
              this.listStatus = 3;
            }
          } else {
            this.listStatus = 3;
          }
          this.$toast.clear();
        })
        .catch(() => {
          this.listStatus = 3;
        });
    },
  },
};
